.slider {
  display: flex;
  position: relative;
  align-items: center;
  width: 100%;
  padding: 0 0.4375rem;
  border-radius: 0.5rem;
  overflow: hidden;
  background-color: var(--neutral-200);

  .input {
    z-index: 200;
    position: relative;
    width: 100%;
    height: 2.625rem;
    margin: 0;
    border: none;
    cursor: pointer;
    background-color: transparent;
    appearance: none;
    -moz-appearance: none;
    -webkit-appearance: none;

    &::-webkit-slider-thumb {
      width: 1.75rem;
      height: 1.75rem;
      border: none;
      border-radius: 0.375rem;
      background-color: var(--neutral);
      box-shadow: 0 0.0625rem 0.375rem -0.125rem rgba(var(--neutral-800-rgb), 0.3);
      transition: transform 0.3s ease;
      appearance: none;
      -webkit-appearance: none;
      -moz-appearance: none;
    }
  }

  .progress {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: var(--primary-700);
    transform-origin: 0 0;
  }
}
